const template = {
	choose_template: "Select Operating System or Application",
	default_category: "Other",
	information_dialog: {
		title: "More information about template ",
	},
	other_os:
		"Is an OS not available as a template? We might be able to upload your ISO. Please create a request, Click here.",
	title: "Create New VPS",
};

export default template;
